import ChatIcon from "@mui/icons-material/ChatBubbleOutline";
import BuildYourBedColumn1 from "../StaticBuildYourBed/BuildYourBedColumn1";
import BuildYourBedColumn2 from "../StaticBuildYourBed/BuildYourBedColumn2";
import EmailIcon from "@mui/icons-material/MailOutline";

import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header";
import Layout from "../../components/Layout/Layout";

import PhoneIcon from "@mui/icons-material/LocalPhoneOutlined";
import React from "react";
import styled from "styled-components";
import ReturnsSlice5 from "../Returns/ReturnsSlice5";
import ContactUsForm from "./Form";
import emailIcon from '../../assets/images/envelope-regular.png';
import commentIcon from '../../assets/images/comment-regular.png';
import phoneIcon from '../../assets/images/phone.png';

const StyledBodyContainer = styled.div``;
const StaticContactUs = () => {
  return (
    <Layout>
      {/*  Header */}
      <Header showBuildMyBed showCart cartIconColor={"#0F475D"} />
      {/*  Body */}

      <Container>
        <div style={{ display: "flex", gap: "128px" }}>
          <div style={{ minWidth: "720px", position: "relative" }}>
            <Title>Contact Us</Title>
            <QuestionTitle>Let Us Know How We Can Help</QuestionTitle>
            <Text>
              Our sleep experts work hard evr-yday to assist in building and
              evolving your evrbed. We are always ready to answer questions or
              concerns.
            </Text>
            <div style={{ display: "flex", marginTop: "80px", gap: 32 }}>
              <ContactCard>
                <img src={emailIcon} style={{width:"43px", height:"32px"}} /> Email Us <br /> help@evrbed.com
              </ContactCard>
              <ContactCard>
                <img src={commentIcon} style={{width:"40px", height:"34px"}} />
                Chat With a Sleep Expert
              </ContactCard>
              <ContactCard>
                <img src={phoneIcon} style={{width:"36px", height:"35px"}} />
                <span>
                  <p>1-855-387-2339</p>
                  <p>1-855-evr-bed9</p>
                </span>
              </ContactCard>
            </div>
            <LeafDecorator1 />
            {/*<BlueDecorator1 />*/}
          </div>
          <div style={{ minWidth: "720px" }}>
            <ContactUsForm></ContactUsForm>
          </div>
        </div>
      </Container>

      {/*  Footer */}
      <Footer showMenuButton={true} styles={{ zIndex: 1100 }}></Footer>
    </Layout>
  );
};
export default StaticContactUs;

const Sizes = styled.div`
  margin-left: 32px;
  margin-top: 16px;
  width: fit-content;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 5px;
`;

const ContactCard = styled.div`
  width: 160px;
  height: 160px;
  background-color: #abe1fa;
  border-radius: 15px;
  color: #0f475d;
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;

  p {
    margin: 0;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  max-width: 1920px;
  height: 90vh;
  padding: 100px 0 0px 150px;
  overscroll-behavior: contain;
  overflow: auto;
`;

const LeafDecorator1 = styled.div`
  border-radius: 0 40% 0 40%;
  border: 6px solid #b1d34a;
  width: 24vw;
  height: 55vh;
  position: absolute;
  left: 500px;
  top: -100px;
  opacity: 8%;
  z-index: 90;
`;

const BlueDecorator1 = styled.div`
  border-radius: 0 40% 0 40%;
  background-color: #abe1fa;
  width: 5vw;
  height: 10vh;
  position: absolute;
  right: 7.5vw;
  top: 6vh;
  opacity: 40%;
`;

const Title = styled.h1`
  color: #0f475d;
  font-size: 81px;
  font-family: elena-web-basic;
  font-weight: bold;
  margin-bottom: 32px;
`;

const QuestionTitle = styled.h2`
  margin-bottom: 20px;
  color: #0f475d;
  font-size: 30px;
  font-family: noto-sans;
  //font-weight: bold;
`;

const Text = styled.p`
  font-family: noto-sans;
  font-size: 21px;
  color: #0f475d;
  margin-bottom: 46px;
  line-height: 25px;
  width: 80%;
`;
